import type { FC } from 'react'
import last from 'lodash/last'
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@memebattle/ui'
import { Avatar } from '#shared/ui/Avatar'

import { PlayersScoresTableCell } from './PlayersScoresTableCell'
import { PlayersScoresTableHead } from './PlayersScoresTableHead'
import { PlayersScoresTableRow } from './PlayersScoresTableRow'

export interface PlayersScoresTableProps {
  /** Players results */
  players: Array<{ username: string; avatar?: string; roundPoints: number[]; totalPoints: number; isPlayer: boolean; id: string }>
}

const columnsProps = {
  avatar: { sm: 2, md: 1 },
  name: { xs: 6, sm: 4 },
  round: { xs: 3, sm: 'grow' },
  total: { xs: 3, sm: 2, md: 1 },
} as const

export const PlayersScoresTable: FC<PlayersScoresTableProps> = ({ players }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box flex={1} flexDirection="column" overflow="auto" data-test-id="PlayersScoresTable">
      <PlayersScoresTableHead>
        <Grid container spacing={4}>
          {!isMobile && <PlayersScoresTableCell size={columnsProps.avatar}></PlayersScoresTableCell>}
          <PlayersScoresTableCell size={columnsProps.name}>
            <Typography variant="body2">Имя</Typography>
          </PlayersScoresTableCell>
          <PlayersScoresTableCell size={columnsProps.round} sx={{ justifyContent: 'flex-end' }}>
            <Typography variant="body2">Раунд</Typography>
          </PlayersScoresTableCell>
          <PlayersScoresTableCell size={columnsProps.total} sx={{ justifyContent: 'flex-end' }}>
            <Typography variant="body2">Всего</Typography>
          </PlayersScoresTableCell>
        </Grid>
      </PlayersScoresTableHead>
      {players.map(({ username, roundPoints, totalPoints, avatar, isPlayer, id }) => (
        <PlayersScoresTableRow
          key={id}
          bgcolor={isPlayer ? theme.palette.primary.light : theme.palette.primary.lighter}
          data-test-id="PlayersScoresTable-PlayersScoresTableRow"
        >
          <Grid container spacing={4}>
            {!isMobile && (
              <PlayersScoresTableCell size={columnsProps.avatar}>
                <Avatar src={avatar} size="small" />
              </PlayersScoresTableCell>
            )}
            <PlayersScoresTableCell size={columnsProps.name}>
              <Typography variant="h5" whiteSpace="nowrap" overflow="auto">
                {username}
              </Typography>
            </PlayersScoresTableCell>
            <PlayersScoresTableCell size={columnsProps.round} sx={{ justifyContent: 'flex-end' }}>
              <Typography fontWeight={500} variant="h5">
                {last(roundPoints)}
              </Typography>
            </PlayersScoresTableCell>
            <PlayersScoresTableCell size={columnsProps.total} sx={{ justifyContent: 'flex-end' }}>
              <Typography fontWeight={500} variant="h5">
                {totalPoints}
              </Typography>
            </PlayersScoresTableCell>
          </Grid>
        </PlayersScoresTableRow>
      ))}
    </Box>
  )
}

PlayersScoresTable.displayName = 'PlayersScoresTable'
